var exports = {
  "zr": "x620889e6--324bc6--root",
  "HA": "x620889e6--324bc6--amenity-list",
  "mu": "x620889e6--324bc6--amenity-no",
  "iz": "x620889e6--324bc6--amenity-yes",
};

module.exports = exports;
